'use client';

import { useUnit } from 'effector-react';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { useEffect, useMemo } from 'react';
import './ObservabilityRuntime.module.scss';

import { $session } from '@/features/session/model';
import { getClientRollbar } from '@/lib/observability/clientRollbar';
import { Provider, useRollbar } from '@rollbar/react';

const RollbarSync = ({ children }: { children: ReactNode }) => {
    const pathname = usePathname();
    const session = useUnit($session);
    const rollbar = useRollbar();

    useEffect(() => {
        const person =
            session?.authenticated && session.user
                ? {
                      id: String(session.user.id),
                      username: session.user.handle || session.user.user_name,
                  }
                : undefined;

        rollbar.configure({
            payload: {
                context: pathname,
                person,
            },
        });
    }, [pathname, rollbar, session]);

    return <>{children}</>;
};

export const ObservabilityRuntime = ({ children }: { children: ReactNode }) => {
    const rollbar = useMemo(() => getClientRollbar(), []);

    if (!rollbar) {
        return <>{children}</>;
    }

    return (
        <Provider instance={rollbar}>
            <RollbarSync>{children}</RollbarSync>
        </Provider>
    );
};
